import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import Layout from '~/components/Layout'
import { RouteTypes } from '~/routes/constants'
import { El } from '~/components/Layout/style'
import { useNavigate, useParams } from 'react-router-dom'
import { handleErrors } from '~/utils/helpers'
import { IndividualFiltersService } from '~/api/services/individualFilters'
import notify from '~/components/Notify'
import { FormFields } from '~/components/FormFields'
import { Form } from 'semantic-ui-react'

const CreateEditRadFilter: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { id } = useParams()

  const [isBusy, setIsBusy] = useState(false)

  const { control, handleSubmit, reset } = useForm({
    mode: 'onSubmit',
    defaultValues: {
      name: '',
      radius: 20,
      longitude: 13.3845921,
      latitude: 52.5309825
    }
  })

  /*   const [
    watchLatitude,
    watchLongitude,
    watchRadius
  ] = watch(['latitude', 'longitude', 'radius']) */

  useEffect(() => {
    if (id) {
      fetchData()
    }
  }, [id])

  async function fetchData() {
    setIsBusy(true)
    try {
      const response = await IndividualFiltersService.filtersRadiusEdit(id)
      reset({
        ...response.data,
        latitude: Number(response.data.latitude),
        longitude: Number(response.data.longitude),
        radius: Number(response.data.radius)
      })
    } catch (error) {
      handleErrors(error)
    } finally {
      setIsBusy(false)
    }
  }

  function renderForm() {
    return <>
      <Form.Group widths={'equal'}>
        <FormFields.Input
          control={control}
          name='name'
          label={t('Name')}
          placeholder={t('Enter name')}
          rules={{
            required: {
              value: true,
              message: t('Please enter name')
            },
            maxLength: {
              value: 150,
              message: t('Max. number of char. is 150!')
            }
          }}
        />
        <FormFields.Input
          control={control}
          placeholder={t('Enter radius')}
          label={t('Radius')}
          typeInput={'controled'}
          suffix={' km'}
          name={'radius'}
          rules={{
            required: {
              value: true,
              message: t('Please enter radius!')
            },
            min: {
              value: 1,
              message: t('Radius must be positive number!')
            }
          }}
        />
      </Form.Group>

      <Form.Group widths={'equal'}>
        <FormFields.Input
          control={control}
          placeholder={t('Enter latitude')}
          label={t('Latitude')}
          decimalScale={7}
          allowDecimals
          typeInput={'controled'}
          suffix={'°'}
          name={'latitude'}
          rules={{
            required: {
              value: true,
              message: t('Please enter latitude!')
            },
            min: {
              value: -90,
              message: t('Min. value is -90°!')
            },
            max: {
              value: 90,
              message: t('Max. value is 90°!')
            }
          }}
        />
        <FormFields.Input
          control={control}
          placeholder={t('Enter longitude')}
          label={t('Longitude')}
          typeInput={'controled'}
          allowDecimals
          decimalScale={7}
          suffix={'°'}
          name={'longitude'}
          rules={{
            required: {
              value: true,
              message: t('Please enter longitude!')
            },
            min: {
              value: -180,
              message: t('Min. value is -180!')
            },
            max: {
              value: 180,
              message: t('Max. value is 180!')
            }
          }}
        />
      </Form.Group>
      {/*  <Form.Field>
        <GoogleMap
          lat={parseFloat(watchLatitude.toString().replace(',', '.'))}
          lng={parseFloat(watchLongitude.toString().replace(',', '.'))}
          radius={watchRadius}
          handleChangeMarkerPosition={(data) => {
            setValue('latitude', data.lat)
            setValue('longitude', data.lng)
          }}
        />
      </Form.Field> */}
    </>
  }

  function renderActions() {
    return <>
      <El.PageHeaderActionButton type='submit'
        disabled={isBusy}
        loading={isBusy}
      >
        {t('Save')}
      </El.PageHeaderActionButton>
      <El.PageHeaderActionButton
        type='button'
        disabled={isBusy}
        loading={isBusy}
        onClick={() => navigate(RouteTypes.DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_RADIUS)}
      >{t('Cancel')}
      </El.PageHeaderActionButton>
    </>
  }

  async function onSubmit(data) {
    setIsBusy(true)
    try {
      if (id) {
        await IndividualFiltersService.filtersRadiusUpdate(id, data)
        notify(t('Successfully updated radius filter'), 'success')
      } else {
        await IndividualFiltersService.filtersRadiusStore(data)
        notify(t('Successfully created radius filter'), 'success')
      }
      navigate(RouteTypes.DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_RADIUS)
    } catch (error) {
      handleErrors(error)
    } finally {
      setIsBusy(false)
    }
  }
  return <Layout
    title={id ? t('Edit radius filter') : t('Create radius filter')}
    onSubmit={handleSubmit(onSubmit)}
    fontSizeHeader={'18px'}
    childContainerSize={'300px'}
    isBusy={isBusy}
    actions={renderActions()}
  >
    {renderForm()}
  </Layout>
}
export default CreateEditRadFilter